"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Table = _interopRequireDefault(require("@insided/deprecated-preact-components/table/Table"));

var _axios = _interopRequireDefault(require("axios"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _Loader = _interopRequireDefault(require("../../ui-components/Loader"));

var _EditModal = require("./EditModal");

var _DeleteModal = require("./DeleteModal");

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _common = require("@insided/deprecated-control/Event/create-event/common");

var _Create = require("../../EmailCampaigns/Create.utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_ERROR_MESSAGE = 'Something went wrong, please try again.';

var EventTypeOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventTypeOverview, _Component);

  var _super = _createSuper(EventTypeOverview);

  function EventTypeOverview(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EventTypeOverview);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      types: [],
      typeToDelete: undefined,
      typeToEdit: undefined,
      isLoading: true,
      showNewTypeModal: false,
      messageType: undefined,
      message: '',
      modalErrorMessage: ''
    });
    _this.onClickEditModalInput = _this.onClickEditModalInput.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EventTypeOverview, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                _context.prev = 1;
                _context.next = 4;
                return _axios.default.get('/settings/eventTypes', {
                  headers: {
                    Accept: 'application/json'
                  }
                });

              case 4:
                res = _context.sent;
                this.setState({
                  types: res.data.types,
                  isLoading: false
                });
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                this.setState({
                  message: 'Failed to fetch event types.',
                  messageType: 'error',
                  isLoading: false
                });
                throw _context.t0;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "deleteType",
    value: function () {
      var _deleteType = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(typeToDelete) {
        var successMessage;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  messageType: undefined
                });
                successMessage = "Event type '".concat(typeToDelete.name, "' has been deleted!");
                _context2.prev = 2;
                _context2.next = 5;
                return _axios.default.delete("/settings/eventType/".concat(typeToDelete.id), {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  }
                });

              case 5:
                this.setState(function (prevState) {
                  var updatedTypes = prevState.types.filter(function (type) {
                    return typeToDelete !== type;
                  });
                  return {
                    types: updatedTypes,
                    message: successMessage,
                    messageType: 'success',
                    isLoading: false
                  };
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                this.setState({
                  message: DEFAULT_ERROR_MESSAGE,
                  messageType: 'error',
                  isLoading: false
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));

      function deleteType(_x) {
        return _deleteType.apply(this, arguments);
      }

      return deleteType;
    }()
  }, {
    key: "editType",
    value: function () {
      var _editType = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(typeToEdit, newName) {
        var successMessage, isNewNameMalicious, _res$data, res, types, _err$response, _err$response$data, errorMessage;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  modalErrorMessage: undefined
                });
                successMessage = "Event type '".concat(typeToEdit.name, "' has been renamed to '").concat(newName, "'!");

                if (newName) {
                  _context3.next = 5;
                  break;
                }

                this.setState({
                  modalErrorMessage: 'Please enter event type',
                  isLoading: false
                });
                return _context3.abrupt("return");

              case 5:
                isNewNameMalicious = (0, _Create.checkMaliciousPayloads)(newName);

                if (!isNewNameMalicious) {
                  _context3.next = 9;
                  break;
                }

                this.setState({
                  modalErrorMessage: 'Please enter event type with no HTML',
                  isLoading: false
                });
                return _context3.abrupt("return");

              case 9:
                _context3.prev = 9;
                _context3.next = 12;
                return _axios.default.post("/settings/eventType/".concat(typeToEdit.id), {
                  oldName: typeToEdit.name,
                  newName: newName
                });

              case 12:
                res = _context3.sent;
                // eslint-disable-next-line react/no-access-state-in-setstate
                types = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.types) || this.state.types;
                this.setState({
                  types: types,
                  message: successMessage,
                  messageType: 'success',
                  isLoading: false,
                  typeToEdit: undefined
                });
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](9);
                errorMessage = (_err$response = _context3.t0.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && _err$response$data.errors ? _context3.t0.response.data.errors : DEFAULT_ERROR_MESSAGE;
                this.setState({
                  modalErrorMessage: errorMessage,
                  isLoading: false
                });

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[9, 17]]);
      }));

      function editType(_x2, _x3) {
        return _editType.apply(this, arguments);
      }

      return editType;
    }()
  }, {
    key: "createType",
    value: function () {
      var _createType = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(newType) {
        var successMessage, isNewTypeMalicious, res, _err$response2, _err$response2$data, errorMessage;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  modalErrorMessage: undefined
                });
                successMessage = "Event type '".concat(newType, "' has been added!");

                if (newType) {
                  _context4.next = 5;
                  break;
                }

                this.setState({
                  modalErrorMessage: 'Please enter event type',
                  isLoading: false
                });
                return _context4.abrupt("return");

              case 5:
                isNewTypeMalicious = (0, _Create.checkMaliciousPayloads)(newType);

                if (!isNewTypeMalicious) {
                  _context4.next = 9;
                  break;
                }

                this.setState({
                  modalErrorMessage: 'Please enter event type with no HTML',
                  isLoading: false
                });
                return _context4.abrupt("return");

              case 9:
                _context4.prev = 9;
                _context4.next = 12;
                return _axios.default.put('/settings/eventType', {
                  typeName: newType
                });

              case 12:
                res = _context4.sent;
                this.setState({
                  types: res.data.types,
                  message: successMessage,
                  messageType: 'success',
                  isLoading: false,
                  showNewTypeModal: false
                });
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](9);
                errorMessage = (_err$response2 = _context4.t0.response) !== null && _err$response2 !== void 0 && (_err$response2$data = _err$response2.data) !== null && _err$response2$data !== void 0 && _err$response2$data.errors ? _context4.t0.response.data.errors : DEFAULT_ERROR_MESSAGE;
                this.setState({
                  modalErrorMessage: errorMessage,
                  isLoading: false
                });

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[9, 16]]);
      }));

      function createType(_x4) {
        return _createType.apply(this, arguments);
      }

      return createType;
    }()
  }, {
    key: "onClickEditModalInput",
    value: function onClickEditModalInput() {
      if (this.state.modalErrorMessage) {
        this.setState({
          modalErrorMessage: undefined
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          types = _this$state.types,
          messageType = _this$state.messageType,
          message = _this$state.message,
          isLoading = _this$state.isLoading,
          typeToDelete = _this$state.typeToDelete,
          typeToEdit = _this$state.typeToEdit,
          showNewTypeModal = _this$state.showNewTypeModal,
          modalErrorMessage = _this$state.modalErrorMessage;
      var isVisibleFor = messageType === 'success' ? 5000 : undefined;
      var rowTypesMapping = types.map(function (type) {
        return [{
          header: 'Event types',
          accessor: 'type-name',
          cell: (0, _preact.h)("span", {
            className: (0, _classnames.default)('pill', 'pill--uppercase', 'qa-type-pill')
          }, (0, _common.getUnescapedName)(type.name))
        }, {
          header: 'Used by',
          accessor: 'used-by',
          cell: (0, _preact.h)("span", null, type.eventsCount.toString(), " ", type.eventsCount === 1 ? 'Event' : 'Events')
        }, {
          header: 'Actions',
          accessor: 'actions',
          cell: (0, _preact.h)("span", null, (0, _preact.h)(_Button.default, {
            title: "Edit",
            onClick: function onClick() {
              return _this2.setState({
                typeToEdit: type,
                messageType: undefined
              });
            },
            "data-track-type": "click",
            "data-element-name": "Edit button"
          }), (0, _preact.h)(_Button.default, {
            title: "Delete",
            variant: "warning",
            onClick: function onClick() {
              return _this2.setState({
                typeToDelete: type
              });
            }
          }))
        }];
      });
      var rows = [].concat((0, _toConsumableArray2.default)(rowTypesMapping), [[{
        accessor: 'new-type',
        cell: (0, _preact.h)(_Button.default, {
          title: "Add new event type",
          variant: "brand",
          onClick: function onClick() {
            return _this2.setState({
              showNewTypeModal: true
            });
          },
          "data-track-type": "click",
          "data-element-name": "Add new event type button"
        }),
        colspan: 3
      }]]);
      return (0, _preact.h)("div", {
        className: "event-types-overview qa-event-types-overview",
        "data-bounded-context": "Event",
        "data-entity": "event-types"
      }, (0, _preact.h)("div", {
        className: "control-header"
      }, (0, _preact.h)("h2", null, "Event Types")), isLoading && (0, _preact.h)(_Loader.default, null), (0, _preact.h)("div", {
        className: "control-body"
      }, messageType ? (0, _preact.h)(_message.default, {
        isControl: true,
        renderHTML: true,
        variant: messageType,
        message: message,
        timer: isVisibleFor,
        onDismiss: function onDismiss() {
          _this2.setState({
            messageType: undefined
          });
        }
      }) : null, typeToDelete ? (0, _preact.h)(_DeleteModal.DeleteModal, {
        type: typeToDelete.name,
        onClose: function onClose() {
          return _this2.setState({
            typeToDelete: undefined
          });
        },
        onDelete: function onDelete() {
          return _this2.setState({
            typeToDelete: undefined,
            isLoading: true
          }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this2.deleteType(typeToDelete);

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })));
        },
        eventsCount: typeToDelete.eventsCount
      }) : null, typeToEdit ? (0, _preact.h)(_EditModal.EditModal, {
        type: typeToEdit.name,
        onClose: function onClose() {
          return _this2.setState({
            typeToEdit: undefined,
            modalErrorMessage: undefined
          });
        },
        onSave: function onSave(newName) {
          return _this2.setState({
            isLoading: true
          }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
            return _regenerator.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this2.editType(typeToEdit, newName);

                  case 2:
                    return _context6.abrupt("return", _context6.sent);

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          })));
        } // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onClick: this.onClickEditModalInput,
        error: modalErrorMessage
      }) : null, showNewTypeModal ? (0, _preact.h)(_EditModal.EditModal, {
        onClose: function onClose() {
          return _this2.setState({
            showNewTypeModal: false,
            modalErrorMessage: undefined
          });
        },
        onSave: function onSave(newName) {
          return _this2.setState({
            isLoading: true
          }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
            return _regenerator.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return _this2.createType(newName);

                  case 2:
                    return _context7.abrupt("return", _context7.sent);

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          })));
        } // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onClick: this.onClickEditModalInput,
        error: modalErrorMessage
      }) : null, (0, _preact.h)(_Table.default, {
        rows: rows,
        classes: ['event-types__table']
      })));
    }
  }]);
  return EventTypeOverview;
}(_preact.Component);

var _default = EventTypeOverview;
exports.default = _default;